import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Search as SearchIcon } from "lucide-react";
import api from "@/lib/api";
import { Loading, Empty } from "@/components/common";

const PATHS = {
  consultation: "/consultas", investigation: "/fiscalizacion", promise: "/promesometro",
  proposal: "/propuestas", entity: "/perfiles", document: "/biblioteca",
};
const LABELS = {
  consultation: "Consulta", investigation: "Fiscalización", promise: "Promesa",
  proposal: "Propuesta", entity: "Perfil", document: "Documento",
};

export default function SearchPage() {
  const [params] = useSearchParams();
  const q = params.get("q") || "";
  const [res, setRes] = useState(null);

  useEffect(() => {
    if (!q) return;
    setRes(null);
    api.get("/search", { params: { q } }).then((r) => setRes(r.data.results)).catch(() => setRes([]));
  }, [q]);

  return (
    <div className="max-w-4xl mx-auto px-6 py-12" data-testid="search-page">
      <div className="flex items-center gap-3 mb-8">
        <SearchIcon className="w-6 h-6 text-slate-400" />
        <h1 className="font-heading font-black text-2xl text-slate-900">Resultados para "{q}"</h1>
      </div>
      {res === null ? <Loading /> : res.length === 0 ? <Empty label="No encontramos resultados." /> : (
        <div className="space-y-3">
          {res.map((r, i) => {
            const to = ["promise"].includes(r.type) ? PATHS[r.type] : `${PATHS[r.type]}/${r.id}`;
            return (
              <Link key={`${r.type}-${r.id}`} to={to} data-testid={`search-result-${i}`}
                className="flex items-center justify-between bg-white rounded-lg border border-slate-200 p-4 hover:shadow-md transition-all">
                <span className="font-medium text-slate-900">{r.title}</span>
                <span className="text-xs font-semibold text-cyan-600 uppercase tracking-wide">{LABELS[r.type]}</span>
              </Link>
            );
          })}
        </div>
      )}
    </div>
  );
}
